<template>
  <div id="app" class="home">
    <Navtop></Navtop>
    <div class="top-tit"></div>
    <div class="home-one">
      <div class="block">
        <div class="swiper-container-one">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in homeonebox" :data-i="item.id" :key="item.id">
              <img :src="item.imgSrc" alt />
            </div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
      <div class="swiper-pagination-one"></div>
    </div>
    <!-- 第二屏 -->
    <div class="home-parttwo">
      <div class="home-parttwo-content">
        <template v-for="item in ipImagesContent">
          <img :src="item.imgSrc" alt="" :key="item.id" v-show="item.display">
        </template>
      </div>
      <div class="home-parttwo-bar">
        <span class="home-parttwo-bar-box" 
          :class="{ 'home-parttwo-bar-active': item.display }"
          @mouseenter="mouseenter(item)"
          :style="{ 'background-image': `url(${ item.imgSrc2 })` }"
          v-for="item in ipImagesContent"
          :key="item.id"
        >
          <span style="height: 15px;" v-html="item.title"></span>
        </span>
      </div>
    </div>
    <div class="partThree">
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <p style="margin-bottom:30px">品牌 x 创意 有趣 x 实用</p>
            <p class="partThree-title"><span style="margin-right:20px;">Brand x Creative Ideas</span><span>Fun x Function</span></p>
            <div class="anliShare">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="item in imgBox" :key="item.id">
                    <img :src="item.imgSrc" alt />
                  </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
              <!-- Add Arrows -->
            </div>
            <div class="swiper-pagination-d"></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <BottomNav></BottomNav>
    <div class="popupBody" :style="display"></div>
    <div class="IPBody" :style="onedisplay"></div>

    <!-- 首页第一屏 -->
    <div class="brand-first" v-show="item.display" v-for="item in homeonebox" :key="item.id">
      <div class="brand-first-tit">
        <span>{{ item.title }}</span>
        <div @click="closeAll(item)">×</div>
      </div>
      <div class="brand-first-father brand-first-bac">
        <img width="100%" :src="item.detailimg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Navtop from "../components/Navtop";
import Logo from "../components/Logo";
import BottomNav from "../components/BottomNav";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "App",
  data() {
    return {
      bannerHeight: "",
      designHeight: "",
      designMiddleHeight: "",
      designRightHeight: "",
      middleHeight: [{ height: "186px" }],
      rightHeight: [{ height: "374px" }],
      designMiddleContentHeight: "",
      display: [{ display: "none" }],
      homefirstDisplay: false,
      onedisplay: [{ display: "none" }],
      firstDisplay: [{ display: "none" }],
      secondDisplay: [{ display: "none" }],
      thirdDisplay: [{ display: "none" }],
      fourthDisplay: [{ display: "none" }],
      swiperDisplay: [{ display: "none" }],
      onefirstDisplay: [{ display: "none" }],
      twosecondDisplay: [{ display: "none" }],
      pointDisplay: [{ display: "none" }],
      imagesBox: [
        {
          id: 0,
          idView: require("../assets/bg-top.png")
        },
        {
          id: 1,
          idView: require("../assets/bg-top.png")
        },
        {
          id: 2,
          idView: require("../assets/bg-top.png")
        }
      ],
      ipImagesContent: [
        {
          id: 0,
          imgSrc: require("../assets/ipxiangqing/dishini.jpg"),
          imgSrc2: require("../assets/ip/dishini.png"),
          title: '迪士尼',
          display: true
        },
        {
          id: 1,
          imgSrc: require("../assets/ipxiangqing/pikesi.jpg"),
          imgSrc2: require("../assets/ip/pikesi.png"),
          title: '皮克斯',
          display: false
        },
        {
          id: 2,
          imgSrc: require("../assets/ipxiangqing/huojiadili.jpg"),
          imgSrc2: require("../assets/ip/guojiadili.png"),
          title: '国家地理',
          display: false
        },
        {
          id: 4,
          imgSrc: require("../assets/ipxiangqing/huanqiu.jpg"),
          imgSrc2: require("../assets/ip/huanqiu.png"),
          title: '环球影业',
          display: false
        },
        {
          id: 3,
          imgSrc: require("../assets/ipxiangqing/feixue.jpg"),
          imgSrc2: require("../assets/ip/feixue.png"),
          title: '费雪',
          display: false
        }, 
        {
          id: 5,
          imgSrc: require("../assets/ipxiangqing/linefriends.jpg"),
          imgSrc2: require("../assets/ip/linefriends.png"),
          title: 'LINE FRIENDS',
          display: false
        },
        {
          id: 6,
          imgSrc: require("../assets/ipxiangqing/tuomasi.jpg"),
          imgSrc2: require("../assets/ip/tuomasi.png"),
          title: '托马斯<br/>和朋友们',
          display: false
        },
        {
          id: 7,
          imgSrc: require("../assets/ipxiangqing/qiaohu.jpg"),
          imgSrc2: require("../assets/ip/qiaohu2.png"),
          title: '巧虎',
          display: false
        }
      ],

      imgBox: [
        {
          id: 0,
          imgSrc: require("../assets/homefour/baishi.png")
        },
        {
          id: 1,
          imgSrc: require("../assets/homefour/caishen.png")
        },
        {
          id: 2,
          imgSrc: require("../assets/homefour/sishini.png")
        },
        {
          id: 3,
          imgSrc: require("../assets/homefour/xiaohuangren-new.png")
        }
      ],
      homeonebox: [
        {
          id: 0,
          imgSrc: require("../assets/home/MinionsNew.jpg"),
          detailimg: require("../assets/home/WechatIMG37New.jpg"),
          title: '2020年圣诞季限定小黄人玩具',
          display: false
        },
        {
          id: 1,
          imgSrc: require("../assets/home/NationalGeographic.jpg"),
          detailimg: require("../assets/home/WechatIMG38.jpeg"),
          title: '惠氏启赋 2020年国家地理整合传播',
          display: false
        },
        {
          id: 2,
          imgSrc: require("../assets/home/wyeth.jpg"),
          detailimg: require("../assets/home/WechatIMG39.jpeg"),
          title: '惠氏启赋 2020年天猫魔法仙境礼盒',
          display: false
        },
        {
          id: 3,
          imgSrc: require("../assets/home/LionKing.jpg"),
          detailimg: require("../assets/home/WechatIMG40.jpeg"),
          title: '惠氏启赋 2019年迪士尼《狮子王》真人电影定制款',
          display: false
        }
      ],
      swiperOption: {
        autoplay: 3000,
        effect: "coverflow"
      }
    };
  },
  methods: {
    closeAll() {
      this.display = { display: "none" };
      this.firstDisplay = { display: "none" };
      this.secondDisplay = { display: "none" };
      this.thirdDisplay = { display: "none" };
      this.fourthDisplay = { display: "none" };
      this.homeonebox.forEach(item => {
        item.display =false
      })
    },
    closeAll1() {
      this.onefirstDisplay = { display: "none" };
      this.twosecondDisplay = { display: "none" };
      this.swiperDisplay = { display: "none" };
      this.onedisplay = { display: "none" };
      this.pointDisplay = { display: "none" };
    },
    displayTop() {
      this.onefirstDisplay = { display: "block" };
      this.twosecondDisplay = { display: "block" };
      this.swiperDisplay = { display: "block" };
      this.onedisplay = { display: "block" };
      this.pointDisplay = { display: "block" };
    },
    openTan() {
      const activeIndex = this.$refs.carousel.activeIndex;
      if (activeIndex == 0) {
        this.fourthDisplay = { display: "block" };
        this.display = { display: "block" };
      }
      if (activeIndex == 1) {
        this.thirdDisplay = { display: "block" };
        this.display = { display: "block" };
      }
      if (activeIndex == 2) {
        this.firstDisplay = { display: "block" };
        this.display = { display: "block" };
      }
      if (activeIndex == 3) {
        this.secondDisplay = { display: "block" };
        this.display = { display: "block" };
      }
    },
    // 首页点击事件
    openTanHome (id) {
      this.display = { display: "block" };
      this.homeonebox.filter(item => item.id === id)[0].display = true
    },
    mouseenter (items) {
      this.ipImagesContent.forEach(item => {
        if (item.id === items.id) {
          item.display = true
        } else {
          item.display = false
        }
      })
    }
  },
  mounted() {
    $("body").scrollTop(0);
    const _this = this
    setTimeout(() => {
      var swiper = new Swiper(".swiper-container", {
        observer: true,
        observerParents: true,
        loop: true,
        initialSlide: 0,
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination-d"
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
      var swiperone = new Swiper(".swiper-container-one", {
        on:{
          click: function(swiper){
            if (swiper.target.nodeName === 'IMG' || swiper.target.nodeName === 'img') {
              _this.openTanHome(this.realIndex)
            }
          },
        },
        observer: true,
        observerParents: true,
        loop: true,
        initialSlide: 0,
        effect : 'coverflow',
        slidesPerView: 1.4,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 70,
          stretch: 1,
          depth: 10,
          modifier: 1,
          slideShadows : true
        },
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination-one"
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    });
    window.onscroll = function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("Navtop");
      if (scrollTop > 0) {
        // topNav.style.zIndex = "11";
        // topNav.style.backgroundColor = "rgba(255,255,255,.5)"
      } else {
        // topNav.style.zIndex = "9";
      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
  },
  components: { Navtop, BottomNav }
};
</script>

<style lang="less" scoped>
.home {
  text-align: center;
  overflow: hidden;

  /deep/ .swiper-container-3d .swiper-slide-shadow-right {
    background: none;
  }

  /deep/ .swiper-container-3d .swiper-slide-shadow-left {
    background: none;
  }

  &-one {
    width: 100%;
    background: #F2F2F3;
    padding-top: 121px;
  }
  &-parttwo {
    width: 65%;
    margin: 0 auto;
    padding: 70px 0;
    box-sizing: border-box;
    // margin-bottom: 51px;

    &-content {
      margin-bottom: 25px;
      width: 100%;
      img {
        width: 100%;
      }
    }
    &-bar {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 25px 0;

      &-box {
        display: inline-block;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        cursor: pointer;
        box-sizing: border-box;
        padding: 20px 0;
        position: relative;

        @media screen and (min-width: 140px) {
          width: 90px;
          height: 90px;
        }
        @media screen and (min-width: 1850px) {
          width: 120px;
          height: 120px;
        }

        span {
          position: absolute;
          bottom: -30px;
          left: 0;
          right: 0;
        }
      }

      &-active {
        border: 4px solid #FCE04F;
        transform: scale(1.2);
        color: #FCE04F;
        background-color: #FCE04F;
      }
    }
  }

  /deep/ .swiper-container-one {
    .swiper-button-next {
      background: none;
      font-size: 36px;
    }
    .swiper-button-next:after {
      color: #7F7F7F !important;
      font-size: 68px !important;
    }
    img {
      cursor: pointer;
    }
    .swiper-button-prev {
      background: none !important;
    }
    .swiper-button-prev::after {
      font-size: 68px !important;
      color: #7F7F7F !important;
    }
  }
}
.el-carousel--card {
  width: 75%;
  margin: 0 auto;
}
// .el-carousel__container {
//   height: 500px;
// }
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // min-width: 1240px;
  position: relative;
  @media screen and (min-width: 140px) {
    min-width: 1050px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1920px) {
    min-width: 1240px;
    margin: 0 auto;
  }
}
.top-tit {
  width: 100%;
  height: 56px;
}
.image {
  width: 100%;
}
.block {
  // min-width: 1240px;
  position: relative;
  background: #F2F2F3;

  &-bac {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  /deep/ .el-carousel__container {
    height: 700px !important;

    @media screen and (min-width: 1920px) {
        height: 1100px !important;
    }
  }
  img {
    width: 100%;
  }
}
.resource {
  margin-bottom: 100px;
  // width: 65%;
  // margin: 0 auto;
  // min-width: 1240px;
  .home-top-img {
    // width: 1240px;
    width: 65%;
    margin: 0 auto;
    display: flex;
    margin-top: 30px;
    justify-content: space-between;
    display: table;
    div {
      width: 34%;
      display: table-cell;
      vertical-align: middle;
      img {
        width: 96%;
      }
      p {
        color: #666;
        @media screen and (min-width: 1440px) {
          font-size: 14px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 16px;
        }
      }
    }
    .home-bian {
      display: table-cell;
      vertical-align: middle;
      width: 31%;
      img {
        width: 96%;
      }
    }
  }
}
.topLogo {
  position: absolute;
  z-index: 1001;
  left: 17.7vw;
  .logo {
    width: 200px;
    height: 212px;
    background: rgba(252, 224, 79, 1);
    text-align: center;
    line-height: 212px;
  }
}
// .logoImg {
//   width: 141px;
//   height: 86px;
// }
.anliShare {
  padding: 0;
  width: 65%;
  margin: 0 auto;
  img {
    width: 100%;
  }
}

.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 60px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 4px solid #fce04f;
    width: 60px;
    margin: 50px 0 20px 0;
  }
  p {
    font-size: 24px;
    margin: 0;
    line-height: 30px;
    font-weight: bold;
    color: #333;
    @media screen and (min-width: 140px) {
      font-size: 18px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 24px;
    }
  }
}
// .topSwiper {
//   width: 1300px;
//   height: 550px;
//   .swiper-slide {
//     text-align: center;
//     font-size: 18px;
//     background: #fff;
//     /* Center slide text vertically */
//     display: -webkit-box;
//     display: -ms-flexbox;
//     display: -webkit-flex;
//     display: flex;
//     -webkit-box-pack: center;
//     -ms-flex-pack: center;
//     -webkit-justify-content: center;
//     justify-content: center;
//     -webkit-box-align: center;
//     -ms-flex-align: center;
//     -webkit-align-items: center;
//     align-items: center;
//     transition: 300ms;
//     transform: scale(0.8);
//     display: flex;
//     flex-flow: column;
//     img {
//       width: 93%;
//       height: 400px;
//       display: block;
//     }
//     p {
//       margin: 0;
//     }
//     .first-swiper-tit {
//       margin-top: 34px;
//     }
//   }
//   .swiper-slide-active {
//     transform: scale(1.1);
//   }
// }
.brandAndDesign {
  height: 190px;
  width: 100%;
  background-color: #333333;
  h1 {
    color: #fce04f;
    display: inline-block;
    font-family: Impact;
    // line-height: 243px;
    font-size: 60px;
    padding-bottom: 5px;
    border-bottom: 4px solid #fce04f;
    margin-right: 30px;
  }
  div {
    display: inline-block;
    color: #ffffff;
    text-align: left;
    vertical-align: bottom;
    padding-bottom: 34px;
    font-weight: bold;
    @media screen and (min-width: 140px) {
      font-size: 18px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 24px;
    }
    p {
      margin: 0;
      line-height: 30px;
    }
  }
}
.brandAndDesignContent {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  // min-width: 1240px;
  .left {
    width: 50%;
    img {
      width: 100%;
    }
  }
  .middle {
    width: 25%;
    img {
      width: 100%;
      display: block;
    }
    div {
      height: 8.2875vw;
      width: 100%;
      min-height: 88px;
      background-color: #fce04f;
      position: relative;
      p {
        margin: 0;
        color: rgba(30, 30, 30, 1);
        line-height: 25px;
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        height: 52px;
        @media screen and (min-width: 140px) {
          font-size: 14px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 16px;
        }
      }
    }
  }
  .right {
    width: 25%;
    img {
      width: 100%;
      display: block;
    }
    div {
      width: 100%;
      height: 12.4vw;
      min-height: 132px;
      background-color: #333333;
      position: relative;
      h3 {
        margin: 0;
        height: 100px;
        font-size: 26px;
        font-weight: bold;
        color: rgba(252, 224, 79, 1);
        line-height: 19px;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;
        @media screen and (min-width: 140px) {
          font-size: 24px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 26px;
        }
      }
      p {
        margin: 0;
        height: 32px;
        font-weight: 400;
        line-height: 25px;
        color: rgba(255, 255, 255, 1);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;
        @media screen and (min-width: 140px) {
          font-size: 14px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 16px;
        }
      }
    }
  }
}
.partThree {
  margin: 0 auto;
  padding-top: 67px;
  padding-bottom: 30px;
  background: #F2F2F3;

  &-title {
    font-family: Source Han Sans SC;
    font-weight: 400 !important;
    font-size: 24px;
    color: #666666 !important;
  }
  img {
    width: 100%;
  }
  h1 {
    margin-left: 47.5%;
    font-size: 60px;
    color: #fce04f;
    padding-right: 10px;
    padding-top: 30px;
    font-family: Impact;
    border-bottom: 4px solid #fce04f;
    width: 60px;
  }
  p {
    margin-bottom: 50px;
    font-weight: bold;
    color: #333;
    line-height: 2px;
    @media screen and (min-width: 1440px) {
      font-size: 18px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 24px;
    }
  }
  .gallery-thumbs {
    height: 161px;
  }
}
.popupBody {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  z-index: 1000;
  opacity: 0.8;
}
.brand-first {
  position: fixed;
  top: 50%;
  margin-top: -300px;
  left: 50%;
  margin-left: -620px;
  width: 1240px;
  z-index: 10000;

  &-bac {
    background-repeat: no-repeat;
    // background-size: cover;
    background-size:100% 100%;
  }

  .brand-first-tit {
    padding: 0 110px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 31px;
      line-height: 27px;
      text-align: center;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .brand-first-father {
    background-color: #ffffff;
    padding: 46px 110px 20px 110px;
    position: relative;
    .brand-first-img {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      .brand-first-left {
        .left-top {
          display: flex;
          justify-content: space-between;
          img {
            width: 297px;
            height: 185px;
          }
          div {
            width: 483px;
            height: 155px;
            background: rgba(252, 224, 79, 1);
            margin-left: 14px;
            padding-top: 30px;
            p {
              color: #333;
              margin: 0;
              line-height: 25px;
              @media screen and (min-width: 140px) {
                font-size: 14px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 16px;
              }
              span {
                color: rgba(51, 51, 51, 1);
              }
            }
          }
        }
        .left-bottom {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          .brand-first-2 {
            width: 422px;
            height: 282px;
          }
          .brand-first-3 {
            width: 156px;
            height: 282px;
          }
          .brand-first-4 {
            width: 188px;
            height: 282px;
          }
        }
      }
      .brand-first-right {
        margin-left: 20px;
        img {
          width: 239px;
          height: 477px;
          margin-left: -10px;
        }
      }
    }
  }
  .brand-first-bg-left {
    position: absolute;
    bottom: 30px;
    left: 0;
  }
  .brand-first-bg-right {
    position: absolute;
    bottom: 20px;
    right: 0;
  }
}
.brand-second {
  position: fixed;
  top: 50%;
  margin-top: -300px;
  left: 50%;
  margin-left: -620px;
  width: 1240px;
  z-index: 10000;
  .brand-second-tit {
    padding: 0 110px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 27px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .brand-second-father {
    background-color: #ffffff;
    padding: 46px 110px 20px 110px;
    position: relative;
    .brand-second-img {
      position: relative;
      z-index: 2;
      .img-top {
        display: flex;
        justify-content: space-between;
        .img-top-1 {
          img {
            width: 340px;
            height: 202px;
          }
          div {
            width: 340px;
            height: 31px;
            background: rgba(252, 224, 79, 1);
            p {
              height: 16px;
              color: rgba(51, 51, 51, 1);
              margin-top: 15px;
              line-height: 31px;
              @media screen and (min-width: 140px) {
                font-size: 14px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 16px;
              }
            }
          }
        }
        .img-top-2 {
          width: 351px;
          height: 248px;
        }
        .img-top-3 {
          width: 160px;
          height: 247px;
        }
        .img-top-4 {
          width: 50px;
          height: 246px;
          background: rgba(252, 224, 79, 1);
          display: flex;
          justify-content: space-between;
          padding: 0 45px;
          color: rgba(51, 51, 51, 1);
          p {
            width: 30px;
            color: rgba(51, 51, 51, 1);
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
      }
      .img-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 23px;
        .img-bottom-1 {
          width: 450px;
          height: 213px;
        }
        div {
          width: 230px;
          height: 43px;
          background: rgba(252, 224, 79, 1);
          padding: 85px 0;
          color: rgba(51, 51, 51, 1);
          line-height: 25px;
          @media screen and (min-width: 140px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 16px;
          }
          p {
            margin: 0;
          }
        }
        .img-bottom-2 {
          width: 323px;
          height: 213px;
        }
      }
    }
  }
  .brand-second-bg-left {
    position: absolute;
    bottom: 30px;
    left: 0;
  }
  .brand-second-bg-right {
    position: absolute;
    bottom: 20px;
    right: 0;
  }
}
.brand-third {
  position: fixed;
  top: 50%;
  margin-top: -300px;
  left: 50%;
  margin-left: -620px;
  width: 1240px;
  z-index: 10000;
  .brand-third-tit {
    padding: 0 110px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 27px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .brand-third-father {
    background-color: #ffffff;
    padding: 46px 110px 20px 110px;
    position: relative;
    .brand-third-img {
      position: relative;
      z-index: 2;
      .img-top {
        display: flex;
        justify-content: space-between;
        & > div {
          width: 519px;
          height: 87px;
          background: rgba(252, 224, 79, 1);
          padding: 70px 0;
          position: relative;
          p {
            color: #333;
            margin: 0;
            line-height: 25px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
          & > div {
            width: 519px;
            height: 227px;
            background: rgba(21, 21, 21, 1);
            position: absolute;
            z-index: -1;
            top: -18px;
            left: -18px;
          }
        }
        .img-top-1 {
          width: 185px;
          height: 230px;
        }
        .img-top-2 {
          width: 328px;
          height: 213px;
        }
      }
      .img-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        .img-bottom-1 {
          width: 173px;
          height: 250px;
        }
        .img-bottom-2 {
          width: 282px;
          height: 250px;
        }
        .img-bottom-3 {
          width: 251px;
          height: 250px;
        }
        .img-bottom-4 {
          width: 239px;
          height: 250px;
        }
      }
    }
  }
  .brand-third-bg-left {
    position: absolute;
    top: 40px;
    left: 65px;
    z-index: 111;
  }
  .brand-third-bg-right {
    position: absolute;
    top: 188px;
    right: 29px;
  }
}
.brand-fourth {
  position: fixed;
  top: 50%;
  margin-top: -300px;
  left: 50%;
  margin-left: -620px;
  width: 1240px;
  z-index: 10000;
  .brand-fourth-tit {
    padding: 0 110px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 27px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .brand-fourth-father {
    background-color: #ffffff;
    padding: 46px 110px 20px 110px;
    position: relative;
    .brand-fourth-img {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      .img-left {
        margin-right: 14px;
        & > img {
          width: 317px;
          height: 222px;
        }
        div {
          position: relative;
          margin-top: 47px;
          .img-left-1 {
            width: 284px;
            height: 136px;
          }
          .img-left-2 {
            position: absolute;
            top: 90px;
            left: 58px;
            width: 200px;
            height: 104px;
          }
        }
      }
      .img-middle {
        margin-right: 14px;

        img {
          width: 399px;
          height: 223px;
        }
        div {
          width: 399px;
          height: 166px;
          background: rgba(252, 224, 79, 1);
          padding-top: 80px;
          margin-top: 5px;
          p {
            color: #333;
            width: 289px;
            padding: 0 55px;
            line-height: 25px;
            margin: 0;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
      }
      .img-right {
        width: 304px;
        height: 491px;
        img{
          width: 100%;
          height: 478px;
        }
      }
    }
  }
  .brand-fourth-bg-left {
    position: absolute;
    bottom: 29px;
    left: 0;
    z-index: 111;
  }
  .brand-fourth-bg-right {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .brand-fourth-bg-top {
    position: absolute;
    top: 136px;
    right: 32px;
  }
}
.IPBody {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  opacity: 0.8;
  z-index: 1000;
}
.IPtankuang {
  position: absolute;
  top: 0px;
  // left: 50%;
  // margin-left: -620px;
  width: 1240px;
  height: 602px;
  z-index: 10000;
  .IP-tit {
    padding: 0 96px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 27px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .IPFather {
    background-color: #ffffff;
    padding: 0 96px 20px 70px;
    position: relative;
    .IPimg {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      padding-top: 10px;
      padding-bottom: 50px;
      .img-left {
        position: relative;
        padding-right: 17px;
        .img-left-top {
          width: 278px;
          height: 460px;
          background: rgba(252, 224, 79, 1);
          .IP-second-1 {
            padding: 33px;
            img {
              width: 56px;
              height: 56px;
            }
            p {
              margin-top: 17px;
              color: #333;
              line-height: 25px;
              @media screen and (min-width: 140px) {
                font-size: 14px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 16px;
              }
            }
          }
          .IP-second-2 {
            display: flex;
            justify-content: space-between;
            padding: 0 33px;
            img {
              width: 64px;
              height: 64px;
            }
            p {
              color: #333;
              line-height: 25px;
              @media screen and (min-width: 140px) {
                font-size: 14px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 16px;
              }
            }
          }
          & > p {
            width: 240px;
            height: 100px;
            color: #333333;
            padding: 0 19px;
            text-align: left;
            line-height: 25px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
        .img-left-bottom {
          position: absolute;
          width: 278px;
          height: 460px;
          background: rgba(51, 51, 51, 1);
          top: 28px;
          left: -28px;
          z-index: -1;
        }
      }
      .img-right {
        position: relative;
        img {
          width: 840px;
          height: 486px;
        }
        .floatImg {
          width: 744px;
          height: 404px;
          position: absolute;
          top: 24px;
          left: 31px;
        }
      }
    }
  }
  .IP-bg {
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
  }
}
.IPtankuang2 {
  position: absolute;
  top: 0px;
  // left: 50%;
  // margin-left: -620px;
  width: 1240px;
  z-index: 10000;
  .IP2-tit {
    padding: 0 96px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 27px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .IP2Father {
    background-color: #ffffff;
    padding: 0 96px 20px 70px;
    position: relative;
    .IP2img {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      padding-top: 54px;
      padding-bottom: 50px;
      margin-left: -10px;
      .img-left {
        position: relative;
        width: 162px;
        height: 403px;
        background-color: #fce04f;
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 114px;
          height: 70px;
        }
      }
      .img-middle {
        position: relative;
        border: 1px solid #666;
        border-left: none;
        padding: 0 20px 0 32px;
        display: flex;
        align-items: center;
        img {
          width: 287px;
          height: 300px;
        }
      }
      .img-right {
        position: relative;
        border: 1px solid #666;
        border-left: none;
        padding: 0 19px 0 19px;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          min-width: 595px;
        }
      }
    }
  }
  .IP2-bg {
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
  }
}
.swiper-container-d {
  width: 1240px;
  height: 689px;
  position: fixed;
  top: 50%;
  margin-top: -345px;
  left: 50%;
  margin-left: -620px;
  z-index: 10000;
  overflow: hidden;
}

.swiper-pagination-one {
  height: 30px;
  padding: 20px 0;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 252px;
}

.swiper-pagination-d {
  // width: 5.2%;
  height: 30px;
  padding: 20px 0;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 252px;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  // display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  // justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 30px !important;
}
.swiper-button-next:after {
  margin-left: 5px !important;
  color: #2A2A2A !important;
}
.swiper-button-prev:after {
  margin-right: 5px !important;
  color: #2A2A2A !important;
}
.swiper-button-next {
  width: 50px;
  height: 50px;
  background-color: #FCE04F;
  border-radius: 50%;
  text-align: center;
  color: #2A2A2A;
}
.swiper-button-prev {
  width: 50px;
  height: 50px;
  background-color: #FCE04F !important;
  border-radius: 50%;
  text-align: center;
  color: #2A2A2A;
}
.swiper-pagination-d {
  .swiper-pagination-bullet-active {
    color: #ccc;
  }
  & > span {
    margin-right: 50px;
  }

  /dee/ .swiper-pagination-bullet {
    width: 48px;
    height: 12px;
    background: #7F7F7F;
    border-radius: 6px;
  }
}
.swiper-pagination-bullet {
  margin-right: 10px !important;
}

.el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0) !important;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 40px;
}
.swiper-button-next:after {
  margin-left: 20px;
}
.swiper-button-prev:after {
  margin-right: 20px;
}
</style>
<style lang="less">
.topSwiper {
  // .swiper-slide-active {
  //   width: 448px !important;
  //   height: 567px !important;
  // }
}
#Navtop {
  width: 100% !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  padding-left: 33.5% !important;
  z-index: 9;
  background-color: rgb(255, 255, 255) !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05) !important;
}
.el-carousel__arrow {
  width: 50px !important;
  height: 50px !important;
}
.el-carousel__arrow i {
  font-size: 30px !important;
}
.el-icon-arrow-down:before {
  content: "" !important;
}
.el-carousel__button {
  width: 11px;
  height: 11px;
  border-radius: 50%;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  color: rgb(158, 158, 158);
  font-size: 20px;
}
.swiper-button-prev:after {
  margin-right: 35px;
}
.swiper-button-next:after {
  margin-left: 35px;
}
.el-carousel__button {
  width: 10px !important;
  height: 10px !important;
  border-radius: 50% !important;
}
.el-submenu__title {
  color: #333 !important;
}
.el-submenu__title a {
  color: #333 !important;
}

// .el-carousel__container {
//   @media screen and (min-width: 140px) {
//     height: 350px !important;
//   }
//   @media screen and (min-width: 1100px) {
//     height: 370px !important;
//   }
//   @media screen and (min-width: 1300px) {
//     height: 400px !important;
//   }
//   @media screen and (min-width: 1500px) {
//     height: 450px !important;
//   }
//   @media screen and (min-width: 1700px) {
//     height: 500px !important;
//   }
//   @media screen and (min-width: 1920px) {
//     height: 521px !important;
//   }
// }
// .anliShare .el-carousel__container {
//   height: 521px;
// }

.home {
  .swiper-pagination-bullet {
    display: inline-block;
    width: 48px;
    height: 12px;
    background: #7F7F7F;
    border-radius: 6px;
  }
}
</style>
